import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "zakat-donation-form" }
const _hoisted_2 = { class: "zakat-amount-section" }
const _hoisted_3 = { class: "amount-display" }
const _hoisted_4 = { class: "currency-symbol" }
const _hoisted_5 = { class: "amount-value" }
const _hoisted_6 = {
  key: 0,
  class: "currency-section"
}
const _hoisted_7 = { class: "el-custom-select" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Amount Display Section "),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "amount-label" }, "Zakat Amount", -1 /* HOISTED */)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString($setup.getSymbol()), 1 /* TEXT */),
        _createElementVNode("span", _hoisted_5, _toDisplayString($setup.formatAmount($props.zakatAmount)), 1 /* TEXT */)
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "amount-note" }, "This amount is calculated based on your Zakat calculation", -1 /* HOISTED */))
    ]),
    _createCommentVNode(" Currency Selection (if multiple currencies supported) "),
    ($props.show_currency_dropdown && $props.currencies)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _cache[3] || (_cache[3] = _createElementVNode("label", { class: "currency-label" }, "Currency", -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_select, {
              class: "w-100",
              modelValue: $setup.store.currency,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.store.currency) = $event)),
              onChange: $setup.onCurrencyChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.currencies, (curr, key) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    value: key,
                    key: key,
                    label: curr
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(curr), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "label"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Purpose Display "),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "purpose-section" }, [
      _createElementVNode("div", { class: "purpose-label" }, "Donation Purpose"),
      _createElementVNode("div", { class: "purpose-value" }, "Zakat")
    ], -1 /* HOISTED */))
  ]))
}